export default __webpack_public_path__ + "static/media/2-1.df7e0014.mp3";